module.exports = "# React Device Kit\na collection of devices written in React "


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./README.md
// module id = 784
// module chunks = 0